module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>Processing</h1>\n<div class="processing">\n    <img src="/static/icons/cog.svg" class="cogicon" /><br/>\n    Preparing names...<br/>\n    This will take a few moments to complete\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./names/templates/processing.html
// module id = 351
// module chunks = 0